import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextField from "canvas-core-react/lib/TextField";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";
import AccountTypeSelect, {
  VALUE_ACCOUNT_TYPE,
} from "../../../../shared/AccountTypeSelect";
import "../../../../../../resources/components/public/utils/custom.css";

const excludeAll = [
  VALUE_ACCOUNT_TYPE.BNS,
  VALUE_ACCOUNT_TYPE.INT,
  VALUE_ACCOUNT_TYPE.LOCAL,
];

const AccountsModal = ({ handleClose, data, handleSave }) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [showInternational, setShowInternational] = useState();

  const [accountIntermediaryteBank, setAccountIntermediaryteBank] =
    useState("");
  const [bicDestinationAccount, setBicDestinationAccount] = useState("");
  const [bicIntermediaryteBank, setBicIntermediaryteBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountType, setAccountType] = useState(VALUE_ACCOUNT_TYPE.BNS);

  const newCurrency =
    data.provider?.accounts[0]?.accountCurrency === "USD" ? "CRC" : "USD";

  useEffect(() => {
    setShowInternational(false);
  }, []);

  const isFormValid = () => {
    let tempErrors = { ...errors };
    if (typeof accountType === "undefined" || accountType == "") {
      tempErrors["accountType"] = `${t("providers.manual.errors.required")}`;
    }

    if (typeof accountNumber === "undefined" || accountNumber == "") {
      tempErrors["accountNumber"] = `${t("providers.manual.errors.required")}`;
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length <= 0;
  };

  const submitForm = () => {
    if (isFormValid()) {
      const body = showInternational
        ? {
            newCurrency,
            accountType,
            accountNumber,
            accountIntermediaryteBank,
            bicDestinationAccount,
            bicIntermediaryteBank,
          }
        : { newCurrency, accountType, accountNumber };

      handleSave(body);
    }
    return false;
  };

  const displayError = (id) => {
    return errors[id] !== undefined ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  };

  const clean = () => {
    setAccountType(VALUE_ACCOUNT_TYPE.BNS);
    setShowInternational(false);
    setAccountIntermediaryteBank("");
    setBicDestinationAccount("");
    setBicIntermediaryteBank("");
    setAccountNumber("");
    setErrors({});
  };

  const onChangePayment = (e) => {
    if (e.target.value === "INT") {
      setShowInternational(true);
    } else {
      setShowInternational(false);
      setAccountIntermediaryteBank("");
      setBicDestinationAccount("");
      setBicIntermediaryteBank("");
    }
    setAccountType(e.target.value);
  };

  const exclude = data.country
    ? newCurrency === "CRC"
      ? [VALUE_ACCOUNT_TYPE.INT]
      : []
    : excludeAll;

  return (
    <div className="modal-container container-modal-xl">
      <div>
        <h2 className="modal-title">{t("providers.accounts.modal.title")}</h2>
      </div>
      <div className="message">
        <div className="profile custom-canvas">
          <Grid fluid={true}>
            <Row justifyContent="spaceBetween">
              <Column lg={6} md={6}>
                <AccountTypeSelect
                  id="accountType"
                  name="accountType"
                  className="default-selector"
                  onChange={onChangePayment}
                  value={accountType}
                  exclude={exclude}
                />
                {displayError("accountType")}
              </Column>
              <Column lg={6} md={6}>
                <TextField
                  name="accountNumber"
                  id="accountNumber"
                  value={accountNumber || ""}
                  onChange={(e) => {
                    var tempErrors = { ...errors };
                    let name = e.target.name;
                    if (errors[name] != "") {
                      delete tempErrors[name];
                      setErrors(tempErrors);
                    }
                    setAccountNumber(e.target.value);
                  }}
                  label={t("providers.accounts.form.accountNumber")}
                />
                {displayError("accountNumber")}
              </Column>
            </Row>
            {showInternational && (
              <>
                <Row justifyContent="spaceBetween">
                  <Column lg={6} md={6}>
                    <TextField
                      label={t(
                        "providers.accounts.form.accountIntermediaryteBank"
                      )}
                      value={accountIntermediaryteBank}
                      onChange={(e) =>
                        setAccountIntermediaryteBank(e.target.value)
                      }
                      name="accountIntermediaryteBank"
                      id="accountIntermediaryteBank"
                    />
                  </Column>
                  <Column lg={6} md={6}>
                    <TextField
                      label={t("providers.accounts.form.bicDestinationAccount")}
                      name="bicDestinationAccount"
                      id="bicDestinationAccount"
                      value={bicDestinationAccount}
                      onChange={(e) => setBicDestinationAccount(e.target.value)}
                    />
                  </Column>
                </Row>
                <Row justifyContent="spaceBetween">
                  <Column lg={6} md={6}>
                    <TextField
                      label={t("providers.accounts.form.bicIntermediaryteBank")}
                      name="bicIntermediaryteBank"
                      id="bicIntermediaryteBank"
                      value={bicIntermediaryteBank}
                      onChange={(e) => setBicIntermediaryteBank(e.target.value)}
                    />
                  </Column>
                </Row>
              </>
            )}
          </Grid>
        </div>
      </div>
      <div className="actions flex-gap">
        <SecondaryButton id="back" onClick={handleClose}>
          {t("providers.accounts.modal.back")}
        </SecondaryButton>
        <SecondaryButton id="clean" onClick={clean}>
          {t("providers.accounts.modal.clean")}
        </SecondaryButton>
        <SecondaryButton id="save" onClick={submitForm}>
          {t("providers.accounts.modal.save")}
        </SecondaryButton>
      </div>
    </div>
  );
};

AccountsModal.propTypes = {
  data: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};
export default AccountsModal;
